import {
  VALIDATION_PATTERNS,
  COORDINATE_LIMITS,
  ADDRESS_MAX_LENGTH,
} from '../constants/validationConstants';

export const validationUtils = {
  /**
   * Sanitizes address input by removing potentially malicious content
   * - Strips HTML/script tags
   * - Removes control characters
   * - Trims whitespace and collapses multiple spaces
   * - Limits length to prevent abuse
   */
  sanitizeAddress: (address: string): string => {
    if (!address) return '';
    
    return address
      // Remove HTML/script tags
      .replace(/<[^>]*>/g, '')
      // Remove control characters (except space, tab, newline)
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
      // Replace newlines and tabs with spaces
      .replace(/[\t\n\r]/g, ' ')
      // Collapse multiple spaces into single space
      .replace(/\s+/g, ' ')
      // Trim whitespace
      .trim()
      // Limit length
      .slice(0, ADDRESS_MAX_LENGTH);
  },

  isValidEmail: (email: string): boolean => {
    return VALIDATION_PATTERNS.EMAIL.test(email);
  },

  isValidNumber: (value: string | number): boolean => {
    if (value === '' || value === null || value === undefined) return false;
    const num = typeof value === 'string' ? parseFloat(value) : value;
    return !isNaN(num) && isFinite(num);
  },

  isValidCoordinates: (
    value: string,
    type: 'latitude' | 'longitude' = 'latitude'
  ): boolean => {
    if (!value || value.trim() === '') return false;
    const num = parseFloat(value);
    if (isNaN(num)) return false;

    if (type === 'latitude') {
      return (
        num >= COORDINATE_LIMITS.LATITUDE_MIN &&
        num <= COORDINATE_LIMITS.LATITUDE_MAX
      );
    } else {
      return (
        num >= COORDINATE_LIMITS.LONGITUDE_MIN &&
        num <= COORDINATE_LIMITS.LONGITUDE_MAX
      );
    }
  },

  isValidLocation: (location: string): boolean => {
    const parts = location.split(',').map((s) => s.trim());
    if (parts.length !== 2) return false;
    return (
      validationUtils.isValidCoordinates(parts[0], 'latitude') &&
      validationUtils.isValidCoordinates(parts[1], 'longitude')
    );
  },
};
